import React from "react";
import { CheckboxContainer, StyledCheckbox, Label } from "./Checkbox.styled";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";

const Checkbox = ({
  label,
  checked,
  onChange,
  name,
  disabled = false,
  required = false,
  error = false,
  ...props
}) => {
  return (
    <CheckboxContainer>
      <StyledCheckbox
        checked={checked}
        onChange={onChange}
        name={name}
        disabled={disabled}
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxOutlinedIcon />}
        error={error}
        {...props}
      />
      <Label disabled={disabled}>
        {label}
        {required && <span className="required"> *</span>}
      </Label>
    </CheckboxContainer>
  );
};

export default Checkbox;
